import MuiAppBar from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import UserIcon from "../Dropdown/UserDropdown";
import Badge from "@mui/material/Badge";

const drawerWidth = 270;

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: "#fff",
  width: `calc(100% - ${open ? drawerWidth : 0}px)`,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: open ? drawerWidth : 0,
  ...(open && {
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    background: "#FFFFFF",
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    height: '100vh',
    overflow: 'hidden',
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

export const TextTypography = () => {
  return (
    <Typography
      component="h1"
      variant="h6"
      color="inherit"
      noWrap
      sx={{ flexGrow: 1 }}
    >
     
    </Typography>
  );
};

export const StatusText = (props) => {
  return (
    <IconButton
      edge="start"
      color="inherit"
      aria-label="open drawer"
      font-size="14px"
    >
      <Typography
        component="h5"
        variant="h7"
        color={props.colors}
        fontSize="15px"
        noWrap
        sx={{ flexGrow: 1 }}
      >
        {props.status}
      </Typography>
    </IconButton>
  );
};

export const UserIcons = () => {
  return (
    <IconButton color="inherit">
      <Badge color="secondary">
        <UserIcon />
      </Badge>
    </IconButton>
  );
};
